export default {
    typeOptions: [
        { id: 0, channelCode: "baidu" },
        { id: 1, channelCode: "intelligent" },
        { id: 2, channelCode: "huawei" },
    ],
    odefinitionOptions: [
        {
            id: 0,
            width: 432,
            height: 768,
            bitrate: 1024,
            fps: 20,
        },
        {
            id: 1,
            width: 576,
            height: 1024,
            bitrate: 2048,
            fps: 30,
        },
        {
            id: 2,
            width: 720,
            height: 1280,
            bitrate: 4096,
            fps: 30,
        },
    ],
    lineOptions: [
        {
            label: "电信",
            ispCode: "ctLine",
        },
        {
            label: "移动",
            ispCode: "cmccLine",
        },
        {
            label: "联通",
            ispCode: "cuLine",
        },
        {
            label: "默认",
            ispCode: "default",
        },
    ],

}